import React from 'react';
import { Header2, Paragraph2 } from '@cian/ui-kit';

import { useOfferContext } from '../../../context';
import { PriceExtensionLabelContainer } from '../PriceExtensionLabelContainer';
import { ContentRow } from '../../../components/ContentRow';

export const PriceContainer: React.FC = ({ children }) => {
  const { priceInfo, price } = useOfferContext();

  return (
    <ContentRow size="L">
      <ContentRow>
        <Header2 data-mark="MainPrice">{price}</Header2>
      </ContentRow>
      {priceInfo && (
        <ContentRow>
          <Paragraph2 data-mark="PriceInfo" color="gray60_100">
            {priceInfo}
          </Paragraph2>
        </ContentRow>
      )}
      {children}
      <PriceExtensionLabelContainer />
    </ContentRow>
  );
};

PriceContainer.displayName = 'PriceContainer';
